import { NgModule } from '@angular/core';
import { SjNgWebglGlobeComponent } from './sj-ng-webgl-globe.component';



@NgModule({
  declarations: [SjNgWebglGlobeComponent],
  imports: [
  ],
  exports: [SjNgWebglGlobeComponent]
})
export class SJNgWebglGlobeModule { }
